<template>
  <section class="section">
    <h3>Endereços</h3>

    <p v-if="!enderecoCollection.items.length" class="flow-text center">
      Nenhum endereço foi cadastrada.
    </p>
    <BaseCollection v-else>
      <template v-slot:items>
        <li
          v-for="(item, index) in enderecoCollection.items"
          v-bind:key="index"
          class="collection-item"
        >
          <BaseEndereco v-bind="item" />
        </li>
      </template>
    </BaseCollection>
  </section>
</template>

<script>
import BaseEndereco from "./BaseEndereco.vue";

export default {
  name: "DadosContatoEnderecos",
  components: {
    BaseEndereco
  },
  inheritAttrs: false,
  props: {
    readonly: Boolean,

    pessoaFisica: {
      type: Object,
      required: true,
      validator: value => value.id !== null && value.id !== undefined
    },
    enderecos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      disabled: false,
      tiposEndereco: [],
      progressBar: {
        useContainer: false
      },
      enderecoCollection: {
        items: this.enderecos.map(item => {
          const value = { ...item };

          return {
            ...this.buildElementProps(item.id),
            value
          };
        })
      }
    };
  },
  methods: {
    buildElementId(itemId, name) {
      return itemId
        ? `dadoscontato-endereco-${itemId}-${name}`
        : this.$utils.Object.uuid();
    },
    buildElementProps(itemId) {
      return {
        logradouro: {
          id: this.buildElementId(itemId, "logradouro"),
          label: "Logradouro",
          gridExpression: "col s12 m9"
        },
        numero: {
          id: this.buildElementId(itemId, "numero"),
          label: "Número",
          gridExpression: "col s12 m3"
        },
        complemento: {
          id: this.buildElementId(itemId, "complemento"),
          label: "Complemento",
          gridExpression: "col s12 m6"
        },
        cep: {
          id: this.buildElementId(itemId, "cep"),
          label: "CEP",
          gridExpression: "col s12 m6"
        },
        bairro: {
          id: this.buildElementId(itemId, "bairro"),
          label: "Bairro",
          gridExpression: "col s12 m6"
        },
        uf: {
          id: this.buildElementId(itemId, "uf"),
          label: "UF",
          gridExpression: "col s12 m6"
        },
        nomeMunicipio: {
          id: this.buildElementId(itemId, "municipio"),
          label: "Município",
          gridExpression: "col s12 m6"
        },
        tipo: {
          id: this.buildElementId(itemId, "tipo"),
          label: "Tipo",
          gridExpression: "col s12 m6"
        }
      };
    }
  }
};
</script>
